module.exports = __webpack_public_path__ + "static/media/profile-admin.d64efd1a.bin";